module.exports = __webpack_public_path__ + "static/media/user-cog.86239b51.svg";